import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsVisibleOnItemGridBaseValueConverter {
    toView(array) {
        if(ObjectHelper.IsNullOrUndefined(array)) {
            return new Array<Object>();
        }
        return array.filter((item) => item.hasOwnProperty('IsVisibleOnItemGrid') && item['IsVisibleOnItemGrid'] == true);
    }
}